var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg0Flat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_1_4587)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5898 16.5391V19.3281C23.5898 20.6641 23.457 21.8047 23.1914 22.75C22.9336 23.6875 22.5586 24.4492 22.0664 25.0352C21.5742 25.6211 20.9844 26.0508 20.2969 26.3242C19.6172 26.5977 18.8555 26.7344 18.0117 26.7344C17.3398 26.7344 16.7148 26.6484 16.1367 26.4766C15.5664 26.3047 15.0508 26.0352 14.5898 25.668C14.1289 25.3008 13.7344 24.8281 13.4062 24.25C13.0859 23.6641 12.8359 22.9648 12.6562 22.1523C12.4844 21.3398 12.3984 20.3984 12.3984 19.3281V16.5391C12.3984 15.1953 12.5312 14.0625 12.7969 13.1406C13.0625 12.2109 13.4414 11.457 13.9336 10.8789C14.4258 10.293 15.0117 9.86719 15.6914 9.60156C16.3789 9.33594 17.1445 9.20312 17.9883 9.20312C18.668 9.20312 19.293 9.28906 19.8633 9.46094C20.4414 9.625 20.957 9.88672 21.4102 10.2461C21.8711 10.6055 22.2617 11.0742 22.582 11.6523C22.9102 12.2227 23.1602 12.9141 23.332 13.7266C23.5039 14.5312 23.5898 15.4688 23.5898 16.5391ZM20.7656 19.7266V16.1172C20.7656 15.4375 20.7266 14.8398 20.6484 14.3242C20.5703 13.8008 20.4531 13.3594 20.2969 13C20.1484 12.6328 19.9609 12.3359 19.7344 12.1094C19.5078 11.875 19.25 11.707 18.9609 11.6055C18.6719 11.4961 18.3477 11.4414 17.9883 11.4414C17.5508 11.4414 17.1602 11.5273 16.8164 11.6992C16.4727 11.8633 16.1836 12.1289 15.9492 12.4961C15.7148 12.8633 15.5352 13.3477 15.4102 13.9492C15.293 14.543 15.2344 15.2656 15.2344 16.1172V19.7266C15.2344 20.4141 15.2734 21.0195 15.3516 21.543C15.4297 22.0664 15.5469 22.5156 15.7031 22.8906C15.8594 23.2578 16.0469 23.5625 16.2656 23.8047C16.4922 24.0391 16.75 24.2109 17.0391 24.3203C17.3359 24.4297 17.6602 24.4844 18.0117 24.4844C18.457 24.4844 18.8516 24.3984 19.1953 24.2266C19.5391 24.0547 19.8281 23.7812 20.0625 23.4062C20.2969 23.0234 20.4727 22.5273 20.5898 21.918C20.707 21.3086 20.7656 20.5781 20.7656 19.7266Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4587",
    x1: 5.4,
    y1: 5.4,
    x2: 31.2,
    y2: 31.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FB5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B559FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0Flat);
export default __webpack_public_path__ + "static/media/0_flat.690d8aa6051435501023e59c14e878cd.svg";
export { ForwardRef as ReactComponent };